"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Title = _interopRequireDefault(require("../../Title"));
var _utils = require("../../utils");
var _FlexTabContainer = _interopRequireDefault(require("../../FlexTabContainer"));
var _CommonContainer = _interopRequireDefault(require("../../CommonContainer"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable no-nested-ternary */
/* eslint-disable eqeqeq */
/* eslint-disable react/display-name */

var TabPane = _FlexTabContainer["default"].TabPane;
var PictureComponent = function PictureComponent(props) {
  var title = props.title,
    text = props.text,
    is = props.is,
    className = props.className,
    ifOpen = props.ifOpen;
  var _a = (0, _react.useState)(false),
    ifshow = _a[0],
    setIfshow = _a[1];
  (0, _react.useEffect)(function () {
    if (ifOpen) {
      setIfshow(ifOpen);
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'faq-tab-list',
    key: is,
    onClick: function onClick() {
      setIfshow(!ifshow);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'faq-tab-list-left'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('faq-tab-list-question', {
      selected: ifshow
    }, className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'faq-tab-list-E'
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10",
    fill: "black",
    fillOpacity: "0.6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.9794 14.2693C11.6279 14.2693 11.3807 14.0977 11.2379 13.7545C11.1006 13.4112 11.0319 12.8013 11.0319 11.9248V9.85743C11.0319 8.65347 11.1555 7.89835 11.4027 7.59208C11.54 7.4231 11.7322 7.33861 11.9794 7.33861C12.3309 7.33861 12.5836 7.52343 12.7374 7.89307C12.8912 8.26271 12.9681 8.82508 12.9681 9.5802V11.5683C12.9681 12.8356 12.8665 13.6304 12.6632 13.9525C12.5259 14.1637 12.298 14.2693 11.9794 14.2693ZM12.828 18C13.7233 18 14.3962 17.8125 14.8465 17.4376C14.8575 17.4271 14.8658 17.4191 14.8713 17.4139V16.3366C14.8218 16.3683 14.7697 16.3947 14.7147 16.4158C14.6598 16.437 14.5966 16.4528 14.5252 16.4634C14.4593 16.4792 14.3879 16.4871 14.311 16.4871C14.0419 16.4871 13.8414 16.4185 13.7096 16.2812C13.5832 16.1439 13.5201 15.864 13.5201 15.4416V15.402C13.9101 15.2911 14.2479 15.138 14.5335 14.9426C14.8246 14.7419 15.0608 14.5096 15.242 14.2455C15.4288 13.9815 15.5798 13.67 15.6952 13.3109C15.8105 12.9465 15.8901 12.5663 15.9341 12.1703C15.978 11.769 16 11.3149 16 10.8079C16 10.3802 15.9863 9.99736 15.9588 9.65941C15.9313 9.32145 15.8819 8.98086 15.8105 8.63762C15.7391 8.29439 15.643 7.99604 15.5221 7.74257C15.4068 7.48383 15.2503 7.24092 15.0525 7.01386C14.8603 6.7868 14.6323 6.60198 14.3687 6.45941C14.105 6.31683 13.7892 6.20594 13.4212 6.12673C13.0532 6.04224 12.6385 6 12.1771 6C11.507 6 10.9248 6.07393 10.4305 6.22178C9.94164 6.36964 9.54068 6.57294 9.2276 6.83168C8.92001 7.09043 8.67285 7.42838 8.4861 7.84554C8.29935 8.25743 8.17027 8.69835 8.09887 9.16832C8.03296 9.63828 8 10.1901 8 10.8238C8 11.204 8.00824 11.5472 8.02472 11.8535C8.04669 12.1597 8.08514 12.4686 8.14006 12.7802C8.19499 13.0865 8.26639 13.3611 8.35427 13.604C8.44765 13.8469 8.56574 14.0792 8.70855 14.301C8.85136 14.5228 9.01888 14.7129 9.21112 14.8713C9.40336 15.0244 9.63405 15.1591 9.90319 15.2752C10.1723 15.3914 10.4744 15.4759 10.8095 15.5287C10.8369 16.4211 11.0017 17.0548 11.3038 17.4297C11.6059 17.8099 12.114 18 12.828 18Z",
    fill: "white"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'faq-tab-list-T'
  }, title)), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'faq-tab-list-answer',
    style: ifshow ? {
      display: 'flex'
    } : {
      display: 'none'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'faq-tab-list-E'
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10",
    fill: "black",
    fillOpacity: "0.6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.144 17H16L13.4008 7H10.1868L10.3735 7.69113L8 17H10.2879L10.5837 15.4044H12.7938L13.144 17ZM11.5875 9.93515L12.4125 13.6638H10.9027L11.5875 9.93515Z",
    fill: "white"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'faq-tab-list-T',
    dangerouslySetInnerHTML: {
      __html: text
    },
    onClick: function onClick(e) {
      e.stopPropagation();
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'faq-tab-list-right'
  }, ifshow ? ( /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: "4",
    y: "11",
    width: "16",
    height: "2",
    fill: "#006EFF"
  }))) : ( /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: "4",
    y: "11",
    width: "16",
    height: "2",
    fill: "black"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "11",
    y: "20",
    width: "16",
    height: "2",
    transform: "rotate(-90 11 20)",
    fill: "black"
  })))));
};
var FaqCom = function FaqCom(props) {
  var icon = props.icon,
    banner = props.banner,
    sharp = props.sharp,
    radius = props.radius,
    source = props.source,
    imageSrc = props.imageSrc,
    flexTitle = props.flexTitle,
    desc = props.desc,
    flexSmallTitle = props.flexSmallTitle,
    mergeComponentStatus = props.mergeComponentStatus,
    style = props.style,
    configuration = props.configuration,
    ifOpen = props.ifOpen,
    className = props.className,
    onClick = props.onClick,
    paddingTopNum = props.paddingTopNum,
    restProps = __rest(props, ["icon", "banner", "sharp", "radius", "source", "imageSrc", "flexTitle", "desc", "flexSmallTitle", "mergeComponentStatus", "style", "configuration", "ifOpen", "className", "onClick", "paddingTopNum"]);
  // 判断是否使用的样式类型 -pc or mobile
  var _a = (0, _react.useState)(true),
    currentClass = _a[0],
    setCurrentClass = _a[1];
  var chilen = configuration.length;
  (0, _react.useEffect)(function () {
    (0, _utils.windowAddEventListener)(setCurrentClass);
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", __assign({
    className: 'flex-default-faq-container',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, restProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-scenarios-container-children'
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    paddingTopNum: '0',
    title: flexTitle,
    desc: desc,
    mergeComponentStatus: mergeComponentStatus,
    flexSmallTitle: flexSmallTitle
  }), currentClass ? ( /*#__PURE__*/_react["default"].createElement("div", {
    className: 'faq-tab'
  }, /*#__PURE__*/_react["default"].createElement(_FlexTabContainer["default"], null, configuration ? configuration.map(function (item, i) {
    var _a = item,
      titleTab = _a.titleTab,
      key = _a.key,
      list = _a.list;
    return /*#__PURE__*/_react["default"].createElement(TabPane, {
      key: i,
      tabIndex: key,
      title: titleTab
    }, /*#__PURE__*/_react["default"].createElement("div", {
      key: i,
      style: key != 1 && chilen == 1 ? {
        display: 'none'
      } : key != 1 ? {
        display: 'none',
        marginTop: '24px'
      } : {
        marginTop: '24px'
      }
    }, list ? list.map(function (items, is) {
      var _a = items,
        title = _a.title,
        text = _a.text;
      return /*#__PURE__*/_react["default"].createElement(PictureComponent, {
        title: title,
        text: text,
        key: is,
        ifOpen: ifOpen
      });
    }) : ''));
  }) : ''))) : ( /*#__PURE__*/_react["default"].createElement(FlexAccordion, {
    style: style,
    configuration: configuration
  }))));
};
function FlexAccordion(props) {
  var configuration = props.configuration,
    style = props.style;
  var _a = (0, _react.useState)(1),
    saveKey = _a[0],
    setSaveKey = _a[1];
  var childrenNodes = {};
  var chilen = configuration.length;
  var getHeightVal = (0, _react.useRef)({});
  (0, _react.useEffect)(function () {
    setTimeout(function () {
      if (getHeightVal) {
        childrenNodes = getHeightVal.current.childNodes;
        // todo optimize
        // 12 初始状态下少12 offsetHeight
        // 24 距离底部距离
        for (var i = 0; i < childrenNodes.length; i++) {
          if (i == 0) {
            getHeightVal.current.childNodes[i].childNodes[0].lastChild.style.height = "auto";
          } else {
            getHeightVal.current.childNodes[i].childNodes[0].lastChild.style.height = "0";
          }
        }
      }
    }, 1000);
  }, []);
  var checkTabsStatus = function checkTabsStatus(key) {
    var childrenNodesVal = getHeightVal;
    var _loop_1 = function _loop_1(i) {
      // 查询到指定要获取高度
      var transformClass = childrenNodesVal.current.childNodes[i].childNodes[0];
      if (i == Number(key) - 1) {
        if (transformClass.className.indexOf('am-accordion-item-leave') > -1) {
          setTimeout(function () {
            // 24 距离底部距离
            transformClass.lastChild.style.height = 'auto';
            // debugger
            // console.log(collectHeight,transformClass.lastChild);
          });
          transformClass.className = 'am-accordion-item';
        } else {
          transformClass.lastChild.style.height = '0';
          transformClass.className = 'am-accordion-item-leave';
        }
      } else {
        transformClass.lastChild.style.height = '0';
        transformClass.className = 'am-accordion-item-leave';
      }
    };
    // todo optimize
    for (var i = 0; i < childrenNodesVal.current.childNodes.length; i++) {
      _loop_1(i);
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'relevance-flex-scene-accordion faq-accordion',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "am-accordion my-accordion"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: getHeightVal
  }, configuration.map(function (item, i) {
    // console.log(item);
    var _a = item,
      list = _a.list,
      titleTab = _a.titleTab,
      // description,
      // tabTitle,
      key = _a.key;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: 'am-accordion-tab',
      key: i
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])({
        'am-accordion-item': i == 0,
        'am-accordion-item-leave': i !== 0
      }),
      onClick: function onClick() {
        if (chilen == 1) {
          return false;
        }
        checkTabsStatus(key);
        if (key === saveKey) {
          setSaveKey(0);
        } else {
          setSaveKey(key);
        }
      },
      style: chilen == 1 ? {
        background: 'none'
      } : {}
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "am-accordion-title",
      role: "button",
      "aria-expanded": "false",
      style: chilen == 1 ? {
        display: 'none'
      } : {}
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'am-accordion-title__scene-tabs-h4'
    }, titleTab), /*#__PURE__*/_react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      className: "design-iconfont d-icon"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      transform: "rotate(-180 12.25 12.25)",
      d: "M12.5 10.8035221L17.6191093 16 19 14.5982389 12.5 8 6 14.5982389 7.3808907 16z",
      fillRule: "evenodd"
    })))), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'am-accordion-container'
    }, list.map(function (vals, keys) {
      var _a = vals,
        title = _a.title,
        text = _a.text;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: 'faq-tab-list-left faq-Mobile',
        key: keys,
        style: {
          height: 'fit-content'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "faq-tab-list-swap"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: 'faq-tab-list-question selected'
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: 'faq-tab-list-E'
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, /*#__PURE__*/_react["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10",
        fill: "black",
        fillOpacity: "0.6"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M11.9794 14.2693C11.6279 14.2693 11.3807 14.0977 11.2379 13.7545C11.1006 13.4112 11.0319 12.8013 11.0319 11.9248V9.85743C11.0319 8.65347 11.1555 7.89835 11.4027 7.59208C11.54 7.4231 11.7322 7.33861 11.9794 7.33861C12.3309 7.33861 12.5836 7.52343 12.7374 7.89307C12.8912 8.26271 12.9681 8.82508 12.9681 9.5802V11.5683C12.9681 12.8356 12.8665 13.6304 12.6632 13.9525C12.5259 14.1637 12.298 14.2693 11.9794 14.2693ZM12.828 18C13.7233 18 14.3962 17.8125 14.8465 17.4376C14.8575 17.4271 14.8658 17.4191 14.8713 17.4139V16.3366C14.8218 16.3683 14.7697 16.3947 14.7147 16.4158C14.6598 16.437 14.5966 16.4528 14.5252 16.4634C14.4593 16.4792 14.3879 16.4871 14.311 16.4871C14.0419 16.4871 13.8414 16.4185 13.7096 16.2812C13.5832 16.1439 13.5201 15.864 13.5201 15.4416V15.402C13.9101 15.2911 14.2479 15.138 14.5335 14.9426C14.8246 14.7419 15.0608 14.5096 15.242 14.2455C15.4288 13.9815 15.5798 13.67 15.6952 13.3109C15.8105 12.9465 15.8901 12.5663 15.9341 12.1703C15.978 11.769 16 11.3149 16 10.8079C16 10.3802 15.9863 9.99736 15.9588 9.65941C15.9313 9.32145 15.8819 8.98086 15.8105 8.63762C15.7391 8.29439 15.643 7.99604 15.5221 7.74257C15.4068 7.48383 15.2503 7.24092 15.0525 7.01386C14.8603 6.7868 14.6323 6.60198 14.3687 6.45941C14.105 6.31683 13.7892 6.20594 13.4212 6.12673C13.0532 6.04224 12.6385 6 12.1771 6C11.507 6 10.9248 6.07393 10.4305 6.22178C9.94164 6.36964 9.54068 6.57294 9.2276 6.83168C8.92001 7.09043 8.67285 7.42838 8.4861 7.84554C8.29935 8.25743 8.17027 8.69835 8.09887 9.16832C8.03296 9.63828 8 10.1901 8 10.8238C8 11.204 8.00824 11.5472 8.02472 11.8535C8.04669 12.1597 8.08514 12.4686 8.14006 12.7802C8.19499 13.0865 8.26639 13.3611 8.35427 13.604C8.44765 13.8469 8.56574 14.0792 8.70855 14.301C8.85136 14.5228 9.01888 14.7129 9.21112 14.8713C9.40336 15.0244 9.63405 15.1591 9.90319 15.2752C10.1723 15.3914 10.4744 15.4759 10.8095 15.5287C10.8369 16.4211 11.0017 17.0548 11.3038 17.4297C11.6059 17.8099 12.114 18 12.828 18Z",
        fill: "white"
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'faq-tab-list-T'
      }, title)), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'faq-tab-list-answer'
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: 'faq-tab-list-E'
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
      }, /*#__PURE__*/_react["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "10",
        fill: "black",
        fillOpacity: "0.6"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M13.144 17H16L13.4008 7H10.1868L10.3735 7.69113L8 17H10.2879L10.5837 15.4044H12.7938L13.144 17ZM11.5875 9.93515L12.4125 13.6638H10.9027L11.5875 9.93515Z",
        fill: "white"
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'faq-tab-list-T',
        dangerouslySetInnerHTML: {
          __html: text
        }
      }))));
    }))));
  }))))));
}
var FAQ = function FAQ(props) {
  var paddingTopNum = props.paddingTopNum,
    paddingBottomNum = props.paddingBottomNum,
    flexTitle = props.flexTitle,
    style = props.style,
    isFooterPart = props.isFooterPart,
    isCombination = props.isCombination;
  return /*#__PURE__*/_react["default"].createElement(_CommonContainer["default"], {
    paddingTopNum: paddingTopNum,
    paddingBottomNum: paddingBottomNum,
    flexTitle: flexTitle,
    style: style,
    isFooterPart: isFooterPart,
    isCombination: isCombination
  }, /*#__PURE__*/_react["default"].createElement(FaqCom, __assign({}, props)));
};
var _default = exports["default"] = FAQ;